import {
  Container,
  Row,
  Col,
} from "react-bootstrap";

const CustomSection = ({customDataSection, menuId, themeColor}) => {
  return (
    <div style={{background: `linear-gradient(360deg, ${themeColor} -700%, #eef2ff30)`}}>
      <Container id={menuId} className="py-5" >
        <Row className="text-center mb-5">
          <Col>
            <h2 className="fw-bold">{customDataSection?.customDataSectionTitle}</h2>
            <p className="text-muted fs-5 mt-2">
              {customDataSection?.customDataSectionSubTitle}
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md={8}>
            <div className="position-relative">
              <div
                style={{
                  position: "absolute",
                  left: "7px",
                  top: 0,
                  bottom: 0,
                  width: "2px",
                  background: "#dee2e6",
                }}
              />
              {(customDataSection?.customData || []).map((exp, i) => (
                <div key={i} className="d-flex mb-5">
                  <div
                    style={{
                      width: 16,
                      height: 16,
                      borderRadius: "50%",
                      background: themeColor,
                      position: "absolute",
                    }}
                  />
                  <div className="ms-4">
                    <h5 className="fw-bold mb-1">{exp.title}</h5>
                    <div className="text-muted small">
                      {exp.subtitle} • {exp.startDate}-{exp.endDate}
                    </div>
                    <p className="text-muted mt-2 mb-0">{exp.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CustomSection;
